import React, { useState, useEffect } from 'react'; // Import React and useState, useEffect hooks
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'; // Import Material-UI components
import '../../assets/styles/dropdown.css';
 // Import CSS for dropdown styles

// PatientDropdown component
function PatientDropdown({ onChange }) {
    // State variables for patients and the selected patient
    const [patients, setPatients] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState('');

    // useEffect hook to fetch patients when the component mounts
    useEffect(() => {
        const fetchPatients = async () => {
            try {
                // Fetch patients from the backend
                const response = await fetch('https://dashboard.encora-internal.com/api/get_patients', { 
                    method: 'GET',
                    credentials: 'include'
                });
                const data = await response.json();
                setPatients(data); // Set the fetched patients to state
            } catch (error) {
                console.error('Error fetching patients:', error); // Log any errors
            }
        };
        fetchPatients(); // Call the fetch function
    }, []);

    // Handle patient selection change
    const handleSelection = async (e) => {
        const selection = e.target.value; // Get the selected patient value
        setSelectedPatient(selection); // Update the selected patient state
        onChange(selection); // Call the onChange function passed as a prop with the selected patient
        // Send the selected patient to the backend
        await fetch('https://dashboard.encora-internal.com/api/submit_patient', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ selectedOption: selection })
        });
    };

    return (
        // Form control for the dropdown
        <FormControl fullWidth>
            {/* Label for the dropdown */}
            <InputLabel shrink={Boolean(selectedPatient)}>Patient</InputLabel>
            {/* Dropdown for selecting patients */}
            <Select value={selectedPatient} onChange={handleSelection}>
                {/* Map over patients to create dropdown menu items */}
                {patients.map((patient, index) => (
                    <MenuItem key={index} value={patient.key}>
                        {patient.data}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

// Export the PatientDropdown component
export default PatientDropdown;
